import React, { useEffect, useState } from 'react';
import {
    Button,
    FlexDirectionRow,
    FormContainer,
    MainContainer,
    MainContent,
    SubTitle,
    Title,
} from '../../../../../components/StyledComponents';
import Input from '../../../../../components/InputControlled';
import { Controller, useForm } from 'react-hook-form';
import { valueIsRequired } from '../../../../../utils/regex';
import { handleModalStatus } from '../../../../../utils/handleModalStatus';
import { BaSeDialogContext, BaSeIcon } from '@base/react';
import { useHistory, useParams } from 'react-router';
import Spinner from 'react-spinner-material';
import { UserActionsContent } from '../../../../../components/UserActionsContent';
import { PerfilUsuarioService } from '../../../services/PerfilUsuarioService';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { ImCheckboxChecked, ImCheckboxUnchecked } from 'react-icons/im';

import LogoRelatorio from '../../../../../images/logoRelatorio.png';
import styles from '../IncluirListaUsuario/styles.module.scss';
import Select from '../../../../../components/Select';
import ufService from '../../../../../services/ufService';

export const EditarListaUsuario = () => {
    const {id} = useParams();
    const {control, handleSubmit, reset, formState, watch, setValue, getValues} = useForm({
        defaultValues: {
            id: '',
            uf: {},
            nome: '',
            perfil: [],
            cpf: '',
        }
    });
    const {isSubmitting} = formState;
    const {showModal} = React.useContext(BaSeDialogContext);
    
    const [dataUfs, setDataUfs] = useState();
    const [perfis, setPerfis] = useState({content: []});
    
    const perfilSelecionado = watch('perfil');
    
    const history = useHistory();
    
    const handleGoHome = () => {
        history.push('/reports', {screen: 'PerfilUsuarios'});
    };
    
    const getDataUfs = async () => {
        const response = await ufService.listar()
        if (!response) return;
        const filteredUfs = response?.filter((i) => i.sigla !== 'NA');
        setDataUfs(filteredUfs);
    };
    
    const findTipo = async () => {
        const response = await PerfilUsuarioService.findAdministradorById(id);
        reset(response);
        setValue('perfil', response?.perfis);
    
    };
    const findPerfis = async () => {
        const result = await PerfilUsuarioService.findAllPerfil(`?&page=0&linesPerPage=100&orderBy=nome&direction=ASC`);
        setPerfis(result);
    };
    
    useEffect(() => {
        findTipo();
        findPerfis();
        getDataUfs();
        // https://github.com/facebook/create-react-app/issues/6880
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    
    const submitForm = async (dataForm) => {
        try {
            dataForm.id = id;
            const response = await PerfilUsuarioService.updateLista(dataForm);
            handleModalStatus({
                type: 'success',
                msgOnSuccess: 'Usuário editado com sucesso.',
                onCloseModal: handleGoHome,
                showModal,
            });
            return response;
        } catch (e) {
            handleModalStatus({
                type: 'error',
                showModal,
            });
        }
    };
    
    const removerDuplicados = (array, propriedade) => {
        const mapa = new Map();
        return array.filter(obj => !mapa.has(obj[propriedade]) && mapa.set(obj[propriedade], obj));
    };
    
    
    const handleAutocompleteChange = (event, value) => {
        const currentValues = getValues('perfil');
        const uniqueValues = removerDuplicados(value, 'id');
        const addedItem = value[value.length - 1];
        const inArray = currentValues.some(u => u.id === addedItem?.id)
        if (inArray) {
            const filteredValues = uniqueValues.filter(u => u.id !== addedItem?.id);
            setValue('perfil', filteredValues || []);
            return;
        }
        setValue('perfil', uniqueValues || []);
    };
    
    
    return (
        <>
            <MainContainer backgroundColor={'#00ccff'}>
                <FlexDirectionRow>
                    <FlexDirectionRow style={{width: '100%'}}>
                        <img
                            alt="imagem"
                            style={{width: '2.5rem', height: '2.5rem'}}
                            src={LogoRelatorio}
                        />
                        <Title>Relatórios</Title>
                    </FlexDirectionRow>
                    <BaSeIcon
                        onClick={handleGoHome}
                        name={'arrow-circle-left'}
                        description="voltar"
                        color="#ffffff"
                        size={50}
                    />
                </FlexDirectionRow>
            </MainContainer>
            <MainContent>
                <SubTitle>
                    <h3>Perfil de usuário: Editar</h3>
                </SubTitle>
                
                <FormContainer>
                    <div style={{flex: 1}}>
                        <Input
                            name="cpf"
                            control={control}
                            rules={{...valueIsRequired()}}
                            placeholder="CPF"
                            maxLength={140}
                            borderRadius="6px"
                        />
                        <div style={{marginTop: '-1rem'}}>
                            <label htmlFor="name">Perfil do usuário</label>
                            <div className={styles.auto_complete_area}>
                                <Controller
                                    name="perfil"
                                    control={control}
                                    defaultValue={[]}
                                    render={({field}) => (
                                        <Autocomplete
                                            {...field}
                                            onChange={handleAutocompleteChange}
                                            multiple={true}
                                            size="small"
                                            id="checkboxes-tags-demo"
                                            options={perfis.content}
                                            disableCloseOnSelect
                                            getOptionLabel={(option) => option?.nome}
                                            renderOption={(props, option) => {
                                                const selected = perfilSelecionado.find(o => o.id === option.id)
                                                return (
                                                    <li {...props}>
                                                        <div style={{marginRight: '0.5rem'}}>
                                                            {!!selected ? (
                                                                <ImCheckboxChecked/>
                                                            ) : (
                                                                <ImCheckboxUnchecked/>
                                                            )}
                                                        </div>
                                                        {option?.nome}
                                                    </li>
                                                );
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    // label="Selecione"
                                                    variant="outlined"
                                                    placeholder="Selecione"
                                                />
                                            )}
                                        />
                                    )}
                                />
                            </div>
                        </div>
                        <Input
                            name="nome"
                            control={control}
                            rules={{...valueIsRequired()}}
                            placeholder="Nome do usuario"
                            maxLength={140}
                            borderRadius="6px"
                        />
                        <Select
                            returnItem={true}
                            name="uf"
                            defaultName={'sigla'}
                            placeholder="UF"
                            options={dataUfs}
                            control={control}
                            rules={{...valueIsRequired()}}
                            borderRadius="6px"
                        />
                    </div>
                    
                    <div style={{flex: 1, paddingBottom: '1rem'}}>
                        <FlexDirectionRow
                            position={'end'}
                            align={'end'}
                            style={{
                                marginRight: '40px',
                                width: '100%',
                                height: '100%',
                            }}
                        >
                            <Button href="#" onClick={handleSubmit(submitForm)}>
                                {isSubmitting ? (
                                    <Spinner
                                        radius={5}
                                        color={'#fff'}
                                        stroke={2}
                                        visible={true}
                                    />
                                ) : (
                                    'Editar Perfil'
                                )}
                            </Button>
                        </FlexDirectionRow>
                    </div>
                </FormContainer>
            </MainContent>
            <UserActionsContent data={getValues()}/>
        </>
    );
};
